import React, { useEffect, useState, useRef } from "react";
import SellTaskPopUp from "./sellTask_popup.js";
import Loading from "../helpers/loading_component.js";
import { secretKey, monthData } from "../.././data";
import Select from "react-select";

const SellSystemCalendar = (props) => {
  const [sellTasks, setSellTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [monthName, setMonthName] = useState("");
  const [weekName, setWeekName] = useState("");
  const [yearName, setYearName] = useState("");
  const [dayName, setDayName] = useState("");
  const [dateC, setDateC] = useState(props.date);
  const [users, setUsers] = useState([]);
  const [showTask, setShowTask] = useState(false);
  const [showTaskId, setShowTaskId] = useState("");
  const [userCalendar, setUserCalendar] = useState(
    props.uData.adminSprzedaz === "1" ? "" : props.uData.name
  );
  const [done, setDone] = useState(true);
  const [undone, setUndone] = useState(true);
  const [taskTypeFilter, setTaskTypeFilter] = useState("");
  const [taskType, setTaskType] = useState([]);
  const [typesOptions, setTypesOptions] = useState([]);

  const [modeCalendar, setModeCalendar] = useState("month");

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchTaskType();
      })
      .catch((error) => {});
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label: el.name,
        value: el.name,
      });
    });

    return bankOptions;
  };

  const fetchTaskType = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl//getSellTaskType", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTaskType(data);
        setTypesOptions(createClientsOptions(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchSellTasks = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellTasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellTasks(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const getMonthName = () => {
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);

    return getMonthData(month) + " " + year;
  };

  const getDayName = () => {
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);

    return "Dzień " + year + "-" + month + "-" + day;
  };

  const getWeekName = () => {
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);

    return "Tydzień " + (weekNumber + 1);
  };

  const getData = () => {
    setLoading(true);

    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    setMonthName(getMonthData(month) + " " + year);
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    fetchSellTasks();
  };

  useEffect(() => {
    getData();
  }, []);

  const scrollBox = (e) => {
    const divToScrollTo = document.getElementById("cb" + e.target.value);

    divToScrollTo.scrollTo({
      top: divToScrollTo.scrollTop + 100,
      behavior: "smooth",
    });
  };

  const createDaySet = () => {
    var date = dateC;
    var dayArray = [];

    dayArray.push(
      `${new Date(date).getFullYear()}-${
        new Date(date).getMonth() + 1
      }-${new Date(date).getDate()}`
    );
    return dayArray;
  };

  const createWeekSet = () => {
    var date = dateC;
    var startYear = new Date(date).getFullYear();
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    var weekStartDate = getDateOfWeek(weekNumber, startYear);
    var weekArray = [];

    for (var i = 0; i <= 6; ++i) {
      var actualDate = addDays(weekStartDate, i);
      weekArray.push(
        `${actualDate.getFullYear()}-${
          actualDate.getMonth() + 1
        }-${actualDate.getDate()}`
      );
    }
    return weekArray;
  };

  const createMonthSet = () => {
    var date = dateC;
    var year = new Date(date).getFullYear();

    var month = new Date(date).getMonth() + 1;
    var begin = new Date(year, month - 1, 1);
    var end = new Date(year, month, 0);
    var startYear = new Date(date).getFullYear();
    var yearStartDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((begin - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumber = 0;
    if (
      new Date(
        new Date(date).getFullYear(),
        new Date(date).getMonth(),
        1
      ).getDay() === 1
    ) {
      weekNumber = Math.ceil(days / 7) + 1;
    } else {
      weekNumber = Math.ceil(days / 7);
    }

    var daysEnd = Math.round((end - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumberEnd = Math.ceil(daysEnd / 7);
    var startDate = getDateOfWeek(weekNumber, startYear);
    var endDate = addDays(getDateOfWeek(weekNumberEnd, startYear), 6);
    var startDate = "";
    if (
      yearStartDate.getMonth() === 0 &&
      yearStartDate.getFullYear() === 2025
    ) {
      startDate = getDateOfWeek1(weekNumber, startYear);
    } else {
      startDate = getDateOfWeek(weekNumber, startYear);
    }
    var endDate = "";
    if (
      yearStartDate.getMonth() === 0 &&
      yearStartDate.getFullYear() === 2025
    ) {
      endDate = addDays(getDateOfWeek1(weekNumberEnd, startYear), 6);
    } else {
      endDate = addDays(getDateOfWeek(weekNumberEnd, startYear), 6);
    }
    var lastDay = end.getDate();
    var daysArray = [];
    var beginCounter = startDate;
    while (beginCounter >= startDate && beginCounter <= endDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() < 10
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${
          beginCounter.getDate() < 10
            ? "0" + beginCounter.getDate()
            : beginCounter.getDate()
        }`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }
    return daysArray;
  };

  const handleCalendarUserChange = (e) => {
    setUserCalendar(e.target.value);
    getData();
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const getMonthData = (monthNum) => {
    var data = monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const getDateOfWeek1 = (w, y) => {
    var d = 1 + (w - 1) * 7;

    return new Date(y, 0, d + 5);
  };

  const getTasks = (date) => {
    var tasks = [];

    if (userCalendar !== "") {
      if (userCalendar === "none") {
        tasks = sellTasks.filter((el) => el.responsible === "");
      } else {
        tasks = sellTasks.filter((el) => el.responsible === userCalendar);
      }
    } else {
      tasks = sellTasks;
    }

    if (taskTypeFilter !== "") {
      tasks = tasks.filter(
        (el) => el.task.replaceAll(" - SKD", "") === taskTypeFilter
      );
    }

    if (done && undone) {
      tasks = tasks.filter(
        (el) => el.status === "ZLECONE" || el.status === "WYKONANE"
      );
    } else if (done && !undone) {
      tasks = tasks.filter((el) => el.status === "WYKONANE");
    } else if (!done && undone) {
      tasks = tasks.filter((el) => el.status === "ZLECONE");
    }
    date = new Date(date);
    tasks = tasks.filter(
      (el) =>
        new Date(el.finalDate).getFullYear() === date.getFullYear() &&
        new Date(el.finalDate).getDate() === date.getDate() &&
        new Date(el.finalDate).getMonth() === date.getMonth()
    );

    return tasks.length > 0 ? tasks : [];
  };

  const getInitials = (user) => {
    var newData = users.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const showTaskPopUp = (e) => {
    setShowTaskId(e.currentTarget.value);
    setShowTask(true);
  };

  const closeTaskPopUp = (e) => {
    setShowTaskId("");
    setShowTask(false);
    getData();
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    users.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const setViewDay = (e) => {
    setDateC(e.target.value);
    setModeCalendar("daily");
  };

  const setView = (e) => {
    setModeCalendar(e.target.value);
  };

  const addDay = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));

    setDateC(retDate);
  };

  const subtractDay = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 1));

    setDateC(retDate);
  };

  const subtractMonths = (numOfMonths) => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - 1));

    setDateC(retDate);
  };

  const addMonths = (numOfMonths) => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + 1));

    setDateC(retDate);
  };

  const subtractWeek = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 7));

    setDateC(retDate);
  };

  const addWeek = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 7));

    setDateC(retDate);
  };

  const setDateNav = (e) => {
    setLoading(true);
    if (modeCalendar === "month") {
      if (e.target.value === "next") {
        addMonths();
      } else if (e.target.value === "previous") {
        subtractMonths();
      }
    }

    if (modeCalendar === "daily") {
      if (e.target.value === "next") {
        addDay();
      } else if (e.target.value === "previous") {
        subtractDay();
      }
    }

    if (modeCalendar === "week") {
      if (e.target.value === "next") {
        addWeek();
      } else if (e.target.value === "previous") {
        subtractWeek();
      }
    }
    getData();
  };

  const createTaskButton = (task) => {
    return (
      <>
        <button
          key={task.id}
          id={
            task.status === "WYKONANE"
              ? "monthLinkTaskDone"
              : "monthLinkTaskSell"
          }
          className="caseLink"
          value={task.id}
          onClick={showTaskPopUp}
        >
          <div className="titleBox">
            <div className="titleBox_col1">
              {task.task + " " + getInitials(task.responsible)}
            </div>
            <div className="titleBox_col2"></div>
          </div>
        </button>
      </>
    );
  };

  const getTasksCountDaily = (dateX) => {
    var dayBox = "";
    var counter = 0;

    getTasks(dateX).map((el) => {
      var dateSet =
        new Date(el.finalDate).getFullYear() +
        "-" +
        (new Date(el.finalDate).getMonth() + 1) +
        "-" +
        new Date(el.finalDate).getDate();
      var dateCheck =
        new Date(dateX).getFullYear() +
        "-" +
        (new Date(dateX).getMonth() + 1) +
        "-" +
        new Date(dateX).getDate();
      if (dateSet === dateCheck) {
        counter++;
      }
    });

    return counter;
  };

  const calendarMonthNew = (
    <>
      <>
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="rowCalendar">
              {createMonthSet().map((el) => (
                <>
                  <div
                    key={el}
                    className="cellCalendar"
                    style={{ padding: "5px" }}
                  >
                    <div
                      id={"cb" + new Date(el).getDate()}
                      className="cellBox"
                      style={{ maxHeight: "18vh" }}
                    >
                      {getTasks(new Date(el)).map((t) => (
                        <>{createTaskButton(t, el)}</>
                      ))}
                    </div>
                    <div className="weekSpecialBoxB">
                      {getTasks(new Date(el)).length > 4 ? (
                        <button
                          value={new Date(el).getDate()}
                          onClick={scrollBox}
                          className="moreButtonCalendar"
                        >
                          ▼
                        </button>
                      ) : (
                        ""
                      )}
                    </div>

                    <span className="cellDayNumber">
                      <button
                        className="dailyButton"
                        value="daily"
                        onClick={setView}
                      >
                        WIDOK DZIENNY
                      </button>
                      <span className="quantityCell">
                        Z: {getTasksCountDaily(el)}
                      </span>{" "}
                      {new Date(el).getDate()}
                    </span>
                  </div>
                </>
              ))}
            </div>
          </>
        )}
      </>
    </>
  );

  const calendarDailyNew = (
    <>
      <div className="rowCalendar">
        {createDaySet().map((el) => (
          <>
            <div key={el} className="colDayCalendar">
              {getTasks(new Date(el)).map((t) => (
                <>{createTaskButton(t, el)}</>
              ))}
            </div>
          </>
        ))}
      </div>
    </>
  );

  const calendarWeekNew = (
    <>
      <div className="rowCalendar">
        {createWeekSet().map((el) => (
          <>
            <div key={el} className="colWeekCalendar">
              <div className="weekContent">
                <p className="colWeekTitle">
                  {new Date(el).getFullYear()}-{new Date(el).getMonth() + 1}-
                  {new Date(el).getDate()}
                </p>
                {getTasks(new Date(el)).map((t) => (
                  <>{createTaskButton(t, el)}</>
                ))}
              </div>
              <span className="cellDayNumber">
                <button className="dailyButton" value="daily" onClick={setView}>
                  WIDOK DZIENNY
                </button>
                <span className="quantityCell">
                  Z: {getTasksCountDaily(el)}
                </span>{" "}
                {new Date(el).getDate()}
              </span>
            </div>
          </>
        ))}
      </div>
    </>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {showTask ? (
          <>
            <SellTaskPopUp
              close={closeTaskPopUp}
              taskId={showTaskId}
              user={props.uData}
              uData={props.uData}
              logLeadAction={props.logLeadAction}
            />
          </>
        ) : (
          <>
            <div style={{ padding: "0" }} className="navigationCalendar">
              <>
                <div className="sectionTitleCalendar">
                  {modeCalendar === "month"
                    ? getMonthName()
                    : modeCalendar === "week"
                    ? getWeekName()
                    : modeCalendar === "daily"
                    ? getDayName()
                    : ""}
                </div>
                <button
                  className="navigationArrow"
                  value="previous"
                  onClick={setDateNav}
                >
                  &#8592;
                </button>
                <button
                  className="navigationArrow"
                  value="next"
                  onClick={setDateNav}
                >
                  &#8594;
                </button>
                {props.uData.adminSprzedaz === "1" ? (
                  <>
                    <select
                      type="text"
                      id="selectShowRecords"
                      name="signature"
                      value={userCalendar}
                      onChange={handleCalendarUserChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      <option key="1" value="none">
                        Nieprzypisane
                      </option>
                      {getUsersForTeam().map((el) => (
                        <option key={el.name} value={el.name}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </>
                ) : userCalendar.length === 0 ? (
                  ""
                ) : (
                  ""
                )}
                <div className="subCheckboxes">
                  <div className="checkBox">
                    <input
                      id="checkCal"
                      type="checkbox"
                      checked={undone}
                      onChange={(e) => setUndone(!undone)}
                    />
                    zlecone
                  </div>
                  <div className="checkBox">
                    <input
                      id="checkCal"
                      type="checkbox"
                      checked={done}
                      onChange={(e) => setDone(!done)}
                    />
                    wykonane
                  </div>
                </div>
                <select
                  type="text"
                  id="selectShowRecords"
                  name="signature"
                  value={taskTypeFilter}
                  onChange={(e) => setTaskTypeFilter(e.target.value)}
                >
                  <option key="0" value="">
                    Wszystkie
                  </option>

                  {taskType.map((el) => (
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  ))}
                </select>
              </>
            </div>
            {modeCalendar === "month"
              ? calendarMonthNew
              : modeCalendar === "week"
              ? calendarWeekNew
              : modeCalendar === "daily"
              ? calendarDailyNew
              : ""}

            <div
              className="sectionTitleCalendarView"
              style={{ padding: "20px 0" }}
            >
              WIDOKI
            </div>
            <div
              className="mainContainerCalendarViews"
              style={{ padding: "0 0" }}
            >
              <button
                className="colCalendarViews"
                value="month"
                onClick={setView}
              >
                MIESIĘCZNY
              </button>
              <button
                className="colCalendarViews"
                value="week"
                onClick={setView}
              >
                TYGODNIOWY
              </button>
              <button
                className="colCalendarViews"
                value="daily"
                onClick={setView}
              >
                DZIENNY
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SellSystemCalendar;
